export default "__VITE_ASSET__BLmfpFaC__"